import classes from '@/components/Shares/Button.module.css';
import { useLingui } from '@lingui/react';
import { Button, type ButtonProps } from '@mantine/core';
export type SocialLinkButtonProps = ButtonProps & {
  handleClick: () => void;
};
export const SocialLinkButton: React.FC<SocialLinkButtonProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Button {...props} onClick={props.handleClick} classNames={{
    root: classes.button_style_2
  }}>
      {i18n._('Link')}
    </Button>;
};